/**
 * @param key {string} key
 * @param value {any}
 */
export const setLocalStorageItem = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (ex) { console.log("localStorage exception", ex); }
}

export const getLocalStorageItem = (key) => {
  let item = null;
  try {
    item = JSON.parse(window.localStorage.getItem(key));
  } catch (ex) { console.log("localStorage exception", ex); }
  return item
}
